(function () {

	$(document).ready(function () {

		const reloadPageElements = $('.reload-page-element');
		reloadPageElements.attr('href', '');

	});

}());